var keywords = require('css-color-names')

function isKeyword (str) {
  return keywords[str] ? true : false
}

module.exports = isKeyword



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-color/lib/isKeyword.js
// module id = 195
// module chunks = 0